import { createAction } from "@reduxjs/toolkit";
import { Organization } from "types/type.organization";

export const loadStyles = createAction<Organization | undefined>(
  "app/loadStyles"
);

export const iterateModule = createAction<{
  selectedStep: { chapterPos: number; questionPos: number };
  selectedTriggers: string[];
}>("app/iterateModule");

export const emptyModule = createAction("app/emptyModule");

export const addTerm = createAction<{ id: string }>("app/addTerm");

export const removeTerm = createAction<string>("app/removeTerm");

export const setCurrentChapter = createAction<number>("app/setCurrentChapter");

export const activateManualForQuestion = createAction<string>(
  "app/activateManualForQuestion"
);

export const deactivateManualForQuestion = createAction<string>(
  "app/deactivateManualForQuestion"
);

export const setHalfPage = createAction<boolean>("app/setHalfPage");

export const setActiveIndex = createAction<number>("app/setActiveIndex");
